import { QuarantineActionStatus } from '../types/actionStatuses';
import { ExchangeProtectionView } from '../view/ExchangeProtectionView';
import { QuarantineItemTypes } from '../types/itemTypes';
import { QuarantinePointType } from '../types/pointType';

export class QuarantineActionEnabler {
  static handleActionButtons(view: ExchangeProtectionView, selectedItems: Array<any>): void {
    let hasPendingInSelection = false;
    let hasGhostItems = false;
    let hasUnrestorableItemsInSelection = false;
    let pendingTypes = [
      QuarantineActionStatus.ACTION_STATUS_PENDING_REMOVE,
      QuarantineActionStatus.ACTION_STATUS_PENDING_SAVE,
      QuarantineActionStatus.ACTION_STATUS_PENDING_RESTORE,
    ];

    for (const selection of selectedItems) {
      hasPendingInSelection = hasPendingInSelection || pendingTypes.includes(selection?.actionStatus);
      hasGhostItems = hasGhostItems || selection.isGhost;

      hasUnrestorableItemsInSelection =
        hasUnrestorableItemsInSelection ||
        selection?.item?.type !== QuarantineItemTypes.ITEM_TYPE_EMAIL ||
        selection?.detection?.pointType !== QuarantinePointType.POINT_TYPE_TRANSPORT;
    }

    const noSelection = selectedItems.length <= 0;

    const disableDeleteAction = noSelection || hasPendingInSelection;

    const disableSaveAction = noSelection || hasPendingInSelection || hasGhostItems;

    const disableRestoreAction =
      noSelection || hasUnrestorableItemsInSelection || hasPendingInSelection || hasGhostItems;

    view.enableSaveExchangeProtection(!disableSaveAction);
    view.enableRestore(!disableRestoreAction);
    view.enableDelete(!disableDeleteAction);
  }
}
